import { translate } from '../../../../../helpers';
import DropDown, { DropDownPropTypes } from '../components/DropDown';
import FilterSearchIcon from '../components/FilterSearchIcon';

const CreatedByDropDown = (props) => (
  <DropDown
    {...props}
    label={translate('rpPlugin.filter.createdBy')}
    labelKey="name"
    valueKey="autodeskId"
    selectClassName="IssueCreateForm__field-width"
    placeholder={translate('rpPlugin.filter.createdByPlaceholder')}
    searchable
    searchIcon={<FilterSearchIcon />}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, ...CreatedByDropDownPropTypes } = DropDownPropTypes;

CreatedByDropDown.propTypes = CreatedByDropDownPropTypes;
export default CreatedByDropDown;
